import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c25cdef6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "default-icon"
}
const _hoisted_2 = ["src"]

import { Ref, ref, watch, onMounted } from "vue";


import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "CSThumbnail",
  methods: {},
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  customCss: {
    type: String,
    default: null,
  },
  backgroundColor: {
    type: String,
    default: "",
  },
  round: {
    type: String,
    default: "0px",
  },
  size: {
    type: String,
    default: "1rem",
  },
  defaultIcon: {
    type: Boolean,
    default: true,
  },
  borderColor: {
    type: String,
    default: "",
  },
  borderWidth: {
    type: Number,
    default: 0,
  },
  url: {
    type: String,
  },
},
  setup(__props) {

const props = __props;



let sUrl: Ref<undefined | string> = ref(undefined);
let isLoaded: Ref<boolean> = ref(false);

onMounted(() => {
  sUrl.value = props.url;
});

watch(
  () => props.url,
  (nValue, oValue) => {
    sUrl.value = nValue;

    if (!props.url) {
      isLoaded.value = false;
    }
  }
);

const onLoad = () => {
  isLoaded.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["thumbnail", __props.customCss]),
    style: _normalizeStyle({ backgroundColor: __props.backgroundColor, borderRadius: __props.round, width: __props.size, height: __props.size, minWidth: __props.size, minHeight: __props.size, borderWidth: __props.borderWidth + 'px', borderColor: __props.borderColor })
  }, [
    (!_unref(isLoaded))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (props.defaultIcon)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "fi fi-rr-user default-icon",
                style: _normalizeStyle({ 'font-size': props.size })
              }, null, 4))
            : _createCommentVNode("", true),
          (!props.defaultIcon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default-icon")
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_unref(sUrl))
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: "thumbnail_img",
          src: _unref(sUrl),
          onLoad: onLoad,
          onerror: "this.style.display='none';"
        }, null, 40, _hoisted_2))
      : _createCommentVNode("", true)
  ], 6))
}
}

})